import { useState, useEffect } from 'react'
import { HStack, VStack, Text, Button, IconButton, Image } from '@chakra-ui/react'
import { LuX } from 'react-icons/lu'
import { useInstallPrompt } from '@utils/hooks/useInstallPrompt'
import { AnimatePresence } from 'motion/react';
import { MotionBox } from '@components/ui/motion';
import { slideFromBottom } from '@utils/motion';

declare global {
  interface Navigator {
    standalone?: boolean;
  }
}

const ua = window.navigator.userAgent.toLowerCase()

const isIos = /iphone|ipad|ipod/.test(ua) || (ua.includes('mac') && navigator.maxTouchPoints > 1)
const isInStandaloneMode =
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export default function InstallBanner() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(
    localStorage.getItem('install-banner-dismissed') === 'true'
  );
  const { canInstall, install } = useInstallPrompt();

  const dismiss = () => {
    localStorage.setItem('install-banner-dismissed', 'true')
    setDismissed(true)
  }

  useEffect(() => {
    setTimeout(() => setVisible(true), 4000);

    window.addEventListener('appinstalled', () => {
      setDismissed(true)
    });
  }, [setDismissed, setVisible]);

  const show = visible && !dismissed && !isInStandaloneMode && (canInstall || isIos);

  return (
    <AnimatePresence>
    {show && (
    <MotionBox
      key="install-banner"
      variants={slideFromBottom}
      initial="initial"
      animate="animate"
      exit="exit"
      position="fixed"
      bottom={16}
      left={16}
      right={16}
      zIndex={10}
      bg="white"
      borderRadius="16px"
      boxShadow="0 8px 30px rgba(0,0,0,0.15)"
      color="gray.900"
      px={2}
      py={2}
    >
      <HStack justify="space-between">
        <HStack>
          <Image
            src="web-app-manifest-192x192.png"
            boxSize="40px"
            borderRadius="10px"
          />

          <VStack align="start" gap={1}>
            <Text fontWeight="bold" fontSize="sm">
              Installer Opentri
            </Text>

             {canInstall ? (
                <Button size="sm" colorPalette="blue" variant="solid" onClick={install}>
                  Télécharger
                </Button>
              ) : (
                <Text fontSize="xs">
                  Partager → Sur l'écran d'accueil
                </Text>
              )}
          </VStack>
        </HStack>
        <HStack>
          <IconButton
            aria-label="dismiss"
            size="sm"
            variant="ghost"
            onClick={dismiss}
          >
            <LuX />
          </IconButton>
        </HStack>
      </HStack>
    </MotionBox>
    )}
    </AnimatePresence>
  );
}
